"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFooterNavigationType = void 0;
var _staticApiClientReact = require("@ori/static-api-client-react");
const getFooterNavigationType = data => data?.application?.navigations.find(item => item.navigationType === _staticApiClientReact.StaticNavigationNavigationItemDtoType.Footer);
exports.getFooterNavigationType = getFooterNavigationType;